<template lang="pug">
  Default
    header.content__header(
      v-esc='hideSearchField'
    )
      button.content__menu-open(
        type='button'
        @click='showSidebar'
      )
      h1.content__title {{ title }}
      .content__header-search(
        v-click-outside='hideSearchField'
      )
        .content__search-field(
          v-if='searchFieldActive'
        )
          SearchField(
            :autofocus='true'
          )
        button.content__search-toggle(
          @click='toggleSearchField'
          :class='{ "is-active": searchFieldActive }'
        ) 
          Icon(
            :name='searchFieldActive ? "close" : "search"'
        )

    .content__body
      .content__showcase(
        v-for='name in slots'
        :key='name'
      )
        slot(
          :name='name'
        )
</template>

<script>
import showSidebar from "@/mixins/shared/showSidebar.mixin";
import showSearchField from "@/mixins/shared/showSearchField.mixin";
import SearchField from "@/components/SearchField/SearchField";
import Icon from "@/components/Icon/Icon";
import Default from "@/layouts/Default";

export default {
  name: "ShowcaseLayout",
  props: {
    title: {
      type: String
    },
    slots: {
      type: Array,
      default: () => []
    }
  },
  mixins: [showSidebar, showSearchField],
  components: {
    Default,
    Icon,
    SearchField
  }
};
</script>
